import React from 'react'

const HeroSection = () => {
  return (
    <div className='hero-section' id='home'>
        <div className="container">
            <div className="row d-flex align-items-center justify-content-between g-lg-4 g-sm-5">
                {/* HERO CONTENT SECTION */}
                <div className="col-lg-4 col-md-6">
                    <div className="hero-content text-md-start text-center">
                        <h1 className='mb-md-5 mb-4 fw-bolder' data-aos='fade-up'>Buy, Sell And <span data-aos='zoom-in' >Collect NFTs.</span> </h1>
                        <p className='text-justify pe-md-5' data-aos='fade-up' >
                        The Worlds Largest Digital Marketplace For Crypto Collectibles And Non-Fungible Tokens
                        </p >
                        <div className='mt-md-5 mt-4 d-flex justify-content-md-start justify-content-center align-items-md-start align-items-center gap-4'>
                            <button data-aos='zoom-in'  className='btn btn-primary'>upload</button>
                            <button data-aos='zoom-in'  className='btn btn-secondary'>explore</button>
                        </div>
                    </div>
                </div>
                {/* HERO IMAGE SECTION */}
                <div className="col-lg-6 col-md-6 mt-0 ">
                    <div className="hero-img position-relative d-flex align-items-center justify-content-center">
                        <img   src="/image/home/hero-img.jpg" className='main-img' alt="" />
                        <img data-aos='zoom-in'  src="/image/home/hero-png.png" className='hero-animation-img' alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default HeroSection
